import ResourceResult from './ResourceResult';
import { Display } from '@/components/Display/Display';
import styles from './style.module.scss';
const RecommendResult = (props) => {
    const { personalized_recommend_result } = props;
    const { output_text = '', resources = [], label = '' } = personalized_recommend_result || {};

    return (
        <>
            <div className={styles['result-text']}>{label || output_text}</div>
            <Display show={resources.length > 0}>
                <ResourceResult resources={resources}></ResourceResult>
            </Display>
        </>
    );
};
export default RecommendResult;
